<div class="video-body">
  <video width="700" height="500" controls>
    <source [attr.src]="videoURL" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>
